import React from 'react';
import './PC.css';
import Ferrero from '../../img/PC/Ferrero.png'
import Khanderia from '../../img/PC/Khanderia.png'
import Singh from '../../img/PC/Singh.png'
import Elsafty from '../../img/PC/Elsafty.png'
import Ibrahim from '../../img/PC/Ibrahim.png'
import Palm from '../../img/PC/Palm.png'
import Deshpande from '../../img/PC/Deshpande.png'
import Kim from '../../img/PC/Kim.png'

export default class PC extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pc: [
        {
          photo: Ferrero,
          name: 'Andrés Mauricio Repetto Ferrero',
          position: 'Machine Learning Engineer',
          github: 'https://github.com/mauricio-repetto',
          ln: 'https://www.linkedin.com/in/a-mauricio-repetto-ferrero-a2954b55/',
          inst: 'https://www.instagram.com/amauri.repetto/',
        },
        {
          photo: Kim,
          name: 'Alexander Kim',
          position: 'MLOps Solutions Engineer',
          ln: 'https://www.linkedin.com/in/alex000kim/',
          github: 'https://github.com/alex000kim',
        },
        {
          photo: Singh,
          name: 'Tajinder Singh',
          position: 'Principal Cloud Software Engineer',
          ln: 'https://www.linkedin.com/in/singh-taj/',
        },
        {
          photo: Khanderia,
          name: 'Jaimin Khanderia',
          position: 'New York University',
          ln: 'https://www.linkedin.com/in/jaimin-khanderia/',
        },
      ],
      pcHide: [
      ],
      hide: true,
    }
    this.togglePC = this.togglePC.bind(this);
  }

  togglePC() {
    this.setState({ hide: !this.state.hide });
  }

  renderPC(item, i) {
    return (
      <div className="pc_item" key={`team-${i}`}>
        <div className="pc_img_block">
          <img className="team_img" src={item.photo} alt={item.name} />
        </div>
        <div className="pc_info">
          <p className="pc_name">{item.name}</p>
          <p className="pc_position">{item.position}</p>
          <div className="pc_links">
            {item.fb && <a className="pc_link social_fb" target='_blank' rel='noreferrer' href={item.fb}></a>}
            {item.ln && <a className="pc_link social_ln" target='_blank' rel='noreferrer' href={item.ln}></a>}
            {item.tw && <a className="pc_link social_tw" target='_blank' rel='noreferrer' href={item.tw}></a>}
            {item.github && <a className="pc_link social_github" target='_blank' rel='noreferrer' href={item.github}></a>}
            {item.website && <a className="pc_link social_website" target='_blank' rel='noreferrer' href={item.website}></a>}
          </div>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className="pc" id='pc'>
        <div className='container team_wrap'>
          <h3>Program committee</h3>
          <div className="pc_block">
            {this.state.pc.map((item, i) => this.renderPC(item, i))}
            {/* {(!this.state.hide || window.innerWidth < 1200) && this.state.pcHide.map((item, i) => this.renderPC(item, i))} */}
          </div>
          {/* <button className='video_btn pc_btn' onClick={this.togglePC}>{this.state.hide ? 'Show more' : 'Hide'}</button> */}
        </div>
      </div>
    )
  }
}